import { calcMinHeight } from './view-box-calc.ts'

function getKartRange() {
  return {
    rangeStart: `exit-crossing 0%`,
    rangeEnd: {
      rangeName: 'exit-crossing',
      // Assuming px height
      /* eslint-disable compat/compat */
      offset: new CSSMathSum(
        CSS.percent(100),
        new CSSMathNegate(CSS.px(calcMinHeight(window.innerWidth))),
      ),
      /* eslint-enable compat/compat */
    },
  }
}

export function setupTimeline(subject) {
  // @ts-ignore
  return new ViewTimeline({
    subject,
    axis: 'block',
  })
}

export function setupKartAnimation(
  viewTimeline: any,
  kartEl: HTMLElement,
  stickyCallback: (sticky: boolean) => void,
) {
  const range = getKartRange()
  const animation = kartEl.animate(
    // using variable so we can react to screen size
    { transform: [`translateY(0px)`, 'translateY(var(--translate-target))'] },
    {
      timeline: viewTimeline,
      ...range,
      fill: 'both',
    },
  )

  // Finished event is emitted every time the map is fully sticky
  animation.addEventListener('finish', () => {
    stickyCallback(true)
  })

  // Observe subject and finished event to track
  const subjectObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          stickyCallback(false)
        }
      })
    },
    {
      rootMargin: `-${calcMinHeight(window.innerWidth)}px 0px 0px 0px`,
    },
  )
  subjectObserver.observe(viewTimeline.subject)

  // Pause animation when section is off viewport
  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          // Pausing the animation will not remove the scroll listener, but will return without performing all the calculations
          animation.pause()
        } else {
          animation.play()
        }
      })
    },
    {
      rootMargin: '300px 0px 0px 0px',
    },
  )
  sectionObserver.observe(viewTimeline.subject.closest('.dh-sa-section'))
  return () => {
    subjectObserver.disconnect()
    sectionObserver.disconnect()
  }
}

export function setupHeadingAnimation(viewTimeline: any, headingEl: HTMLElement) {
  // const details = animationInfo.get(viewTimeline)
  headingEl.animate(
    [{ opacity: 1 }, { opacity: 1, offset: 0.45 }, { opacity: 0, offset: 0.95 }, { opacity: 0 }],
    {
      timeline: viewTimeline,
      // @ts-ignore
      rangeStart: `exit 0%`,
      rangeEnd: `exit 50%`,
      // rangeEnd: `exit: 10%`,
      fill: 'both',
    },
  )
}

export function setupSvgAnimation(
  viewTimeline: any,
  svgContainerEl: HTMLElement,
  svgOffsetEnd: number,
) {
  // const details = animationInfo.get(viewTimeline)
  const range = getKartRange()
  svgContainerEl.animate(
    {
      transform: [
        `translateY(calc(-0.5  * var(--height) + 50%))`,
        `translateY(calc(-0.5  * var(--min-height) + ${svgOffsetEnd.toFixed(4)} * 100%))`,
      ],
    },
    {
      timeline: viewTimeline,
      ...range,
      fill: 'both',
    },
  )

  svgContainerEl.querySelectorAll('.fade-out').forEach((fadeElement) => {
    fadeElement.animate(
      {
        opacity: ['1', '0'],
      },
      {
        timeline: viewTimeline,
        ...range,
        fill: 'both',
      },
    )
  })
}
